import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface SuccessViewProps {
  /**
   * Mensagem composta pelo backend (TenantRegistoResponse#mensagem) — já
   * inclui o email do administrador e o prazo real configurado para a
   * confirmação (app.tenant.confirmacao-email.validade-horas). `null`/`undefined`
   * quando não há resposta disponível (ex: registo por Google, que só chega
   * aqui depois de um redirect do browser sem corpo de resposta) — nesse
   * caso mostra-se um texto genérico com o mesmo prazo por defeito.
   */
  message?: string | null
}

export default function SuccessView({ message }: SuccessViewProps) {
  const { t } = useTranslation('auth')
  const navigate = useNavigate()

  return (
    <Box sx={{ textAlign: 'center', py: 2 }}>
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: 'brand.teal50',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2.5,
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 34, color: 'primary.light' }} />
      </Box>

      <Typography variant="h5" >
        {t('register.success.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {message || t('register.success.checkEmailGeneric')}
      </Typography>

      <Button
        variant="contained"
        size="large"
        fullWidth
        onClick={() => navigate('/dashboard')}
        sx={{marginTop: 10}}
      >
        {t('register.success.goToDashboard')}
      </Button>

      <Button
        variant="text"
        size="large"
        fullWidth
        onClick={() => navigate('/login')}
        sx={{ mt: 1, color: 'text.secondary' }}
      >
        {t('register.success.signIn')}
      </Button>
    </Box>
  )
}
